import React, { useEffect } from "react";
import { Modal, Form, Input, message } from "antd";
import api from "../api";

const ConductorModal = ({ open, conductor, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const isEdit = !!conductor;

  useEffect(() => {
    if (open) {
      if (isEdit && conductor) {
        form.setFieldsValue({
          cedula: conductor.cedula,
          nombre: conductor.nombre,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, conductor, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (isEdit) {
        await api.put(`/conductores/${conductor.idconductores}`, values);
        message.success("Conductor actualizado exitosamente");
      } else {
        await api.post("/conductores", values);
        message.success("Conductor agregado exitosamente");
      }
      form.resetFields();
      onSuccess();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Error al guardar conductor");
      }
    }
  };

  return (
    <Modal
      title={isEdit ? "Editar Conductor" : "Nuevo Conductor"}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Guardar"
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="cedula"
          label="Cédula"
          rules={[{ required: true, message: "La cédula es obligatoria." }]}
        >
          <Input placeholder="Ej. 1234567890" />
        </Form.Item>

        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[{ required: true, message: "El nombre es obligatorio." }]}
        >
          <Input placeholder="Ej. Juan Pérez" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ConductorModal;
